export default __webpack_public_path__ + "static/media/coin.da6fc05c.png";